var map = {
	"./attachment.svg": 9163,
	"./avatar-none.svg": 2042,
	"./bg-intro-org.svg": 679,
	"./bg-program-pdf.svg": 988,
	"./blank-program-white.svg": 218,
	"./blank-program.svg": 3263,
	"./book.svg": 5490,
	"./building.svg": 1089,
	"./check-icon.svg": 4223,
	"./check-outline-icon.svg": 2339,
	"./completed-icon.svg": 8690,
	"./email.svg": 4680,
	"./empty-image.svg": 930,
	"./exercise-template-empty.svg": 838,
	"./eye-slash.svg": 7613,
	"./eye.svg": 1337,
	"./green-check-icon.svg": 1730,
	"./hedge-logo.svg": 7911,
	"./hedge-pdf-logo.svg": 2378,
	"./invalid-icon.svg": 386,
	"./logo-text.svg": 2498,
	"./logo.svg": 148,
	"./logo_text_green.svg": 2579,
	"./org-select.svg": 1125,
	"./patient-empty.svg": 1759,
	"./patient-icon.svg": 6451,
	"./patients-icon.svg": 4558,
	"./photo.svg": 490,
	"./play-icon.svg": 8872,
	"./program-empty.svg": 2368,
	"./program-template-empty.svg": 2873,
	"./program-white.svg": 8632,
	"./program.svg": 153,
	"./search-normal.svg": 5501,
	"./send.svg": 2949,
	"./success-icon.svg": 7464,
	"./success100.svg": 3178,
	"./therapist-empty.svg": 2554,
	"./therapist-icon.svg": 5648,
	"./unarchive-icon.svg": 9743,
	"./upload-icon.svg": 296,
	"./user-setting.svg": 2869,
	"./userCoverImg.svg": 1003,
	"./video-icon.svg": 159,
	"./youtube-play-icon.svg": 8941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1034;